<template>
    <div id="us-all-Journey-cart1">
        <el-table :data="JourneyStoreSingle" class="us-all-Journey-table" @row-click="goToDetail" :default-sort="Settings.journeyoverview.defaultsort" @sort-change="onSort">
            <el-table-column prop="date_from" label="Reisestart" sortable :formatter="formatter" width="120" :sort-method="sortDateFrom"></el-table-column>
            <el-table-column prop="date_till" label="Reiseende" sortable :formatter="formatter" width="120" :sort-method="sortDateTill"></el-table-column>
            <el-table-column prop="duration" label="Reisedauer " sortable width="130" align="center" :sort-method="sortDuration"></el-table-column>
            <el-table-column prop="title" label="Reisetitel" sortable></el-table-column>
            <el-table-column prop="price" label="Preis" sortable :formatter="formatterPrice" align="right" width="150" :sort-method="sortPrice"></el-table-column>
            <el-table-column fixed="right" label="Link zur Reise" width="150" align="right">
                <template slot-scope="scope">
                    <el-button @click.stop.prevent="goToDetail(scope.row)" size="small" style="background-color:#6711a3;color:#FFF;"> zur Reise </el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    computed: {
        ...mapState(["JourneyStoreSingle", "Settings"])
    },

    created() {
        this.getJourneys()
        this.checkTableHeight()
    },

    components: {},

    data() {
        return {
            Jcarts: []
        }
    },
    methods: {
        checkTableHeight() {
            // var el = document.querySelector('.us-all-Journey-table')
            // console.log(el.setAttribute("height", 200))
        },
        formatter(row, column, cellValue, index) {
            return new Intl.DateTimeFormat("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(cellValue))
        },
        formatterPrice(row, column, cellValue, index) {
            var num = cellValue / 1000000
            return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €"
        },
        getJourneys() {
            // core.backend("jrn.listJourneysWeb", {id_acc_account: 2}, (err, res) => {
            //     this.Jcarts = []
            //     res.data.rows.forEach(jrney => {
            //         jrney.dates.forEach(date => {
            //             let _newJourney = JSON.parse(JSON.stringify(jrney))
            //             _newJourney.dates = [date]
            //             this.Jcarts.push(_newJourney)
            //         })
            //     })
            //     // this.Jcarts = JSON.parse(JSON.stringify(res.data.rows)) // hier merken bevor ich christian anrufe
            //     // console.log(JSON.parse(JSON.stringify(res.data.rows)))
            // })
        },
        goToDetail(row) {
            core.navigate({ path: "/journeydetail/" + row.id_jrn_journey })
        },
        sortDateFrom(a, b) {
            return new Date(a.date_till) - new Date(b.date_till)
        },
        sortDateTill(a, b) {
            return new Date(b.date_till) - new Date(a.date_till)
        },
        sortDuration(a, b) {
            return a.duration - b.duration
        },
        sortPrice(a, b) {
            return a.price - b.price
        },
        onSort({ column, prop, order }) {
            this.Settings.journeyoverview.defaultsort = { prop, order }
        }
    }
}
</script>

<style lang="scss">
#us-all-Journey-cart {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
    align-self: flex-end;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

//   .us-all-Journey-table {
//       height:200px;
//       overflow-y:auto;

//   }
//   .usJourneyOverview{
// min-width:320px;
// min-height:320px;
// width:22vw;
// height:22vw;
// position:relative;
// margin:0.5vw;
// margin-bottom:1.5vh;
/* border-radius:5px; */
/* box-sshadow: 0px 0px 10px 0px #979797; */
/* border:1px solid  #979797;     */
//   }
</style>



